import { makeModuleStateSelector } from "@client/content/selectors";
import { TargetSelector, combinedSettingsSelector, getSettingValueSelector } from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type Purchase } from "./types";

export const localStateSelector = makeModuleStateSelector<Purchase.AppState>(defaultState, previewState);

const errorCodePropsSelector = (state: any, props: { errorCode: Purchase.Api.ErrorCode | null }) => props.errorCode;

export const makeAlertSelector = () => {
  const dwmAlertSelector = combinedSettingsSelector<Purchase.Alert>(TargetSelector.Entity, [
    { name: "dwmTitle", prop: "title" },
    { name: "dwmMessage", prop: "message" }
  ]);

  const ewmAlertSelector = combinedSettingsSelector<Purchase.Alert>(TargetSelector.Entity, [
    { name: "ewmTitle", prop: "title" },
    { name: "ewmMessage", prop: "message" }
  ]);

  return createSelector(
    [errorCodePropsSelector, dwmAlertSelector, ewmAlertSelector],
    (errorCode, dwmAlert, ewmAlert): Purchase.Alert | null => {
      switch (errorCode) {
        case "EXISTING_WEBSITE":
          return {
            ...ewmAlert,
            canProceed: true
          };
        case "DEPLOYING_WEBSITE":
          return {
            ...dwmAlert,
            canProceed: false
          };
        default:
          return null;
      }
    }
  );
};

export const makePreloaderStepsSelector = () => {
  const preloaderStepsSelector = getSettingValueSelector(TargetSelector.Entity, "steps", "preloader");

  return createSelector([preloaderStepsSelector], (steps: string) =>
    steps
      .split("\n")
      .map((x) => x.trim())
      .filter((x) => x)
  );
};

export const makeShowExtraButtonSelector = () => getSettingValueSelector(TargetSelector.Entity, "showExtraButton");
